exports.default = {
  'context_cleared': '上下文已清除',
  'select_all': '全選',
  'cancel': '取消',
  'generate_share_link': '生成分享鏈接',
  'share_link_dialog_title': '分享鏈接已生成',
  'share_link_dialog_description': '請點擊「複製鏈接」將分享鏈接複製到剪貼板。',
  'copy_share_link': '複製鏈接',
  'add_to_project': '保存到項目',
  'this_agent_has_been_deleted': '此智能體已刪除！',
  'this_agent_has_been_removed': '此智能體已下架！',
  'please_enter_your_question_or_requirement': '傳送訊息...',
  'single_image_size_no_more_than_50M': '單張圖片大小不超過20M，最多同時上傳10張圖片。',
  'reference_image_upload_hint': '單張圖片大小不超過 20MB，目前模型最多上傳 {count} 張參考圖。',
  'hello': '你好',
  'no_recommended_questions': '沒有推薦問題',
  'loading_recommended_questions': '加載推薦問題：',
  'append_continue_answer': '追加繼續作答',
  'max_turns_stop_title': '執行已暫停',
  'max_turns_stop_description': '已達到本輪最大執行步數，當前進度已保存。是否繼續完成剩餘任務？',
  'max_turns_continue': '繼續生成',
  'max_turns_later': '稍後再說',
  'max_turns_continue_message': '繼續',
  'max_turns_stop_toast': '已達到本輪最大執行步數，進度保存後可繼續對話',

  'video_script_tools': {
    'loading': '正在載入腳本…',
    'directory_empty': '目前對話暫無已儲存的影片腳本',
    'content_empty': '暫無腳本正文',
    'failed': '腳本工具執行失敗，請稍後重試。',
    'stopped': '腳本操作已停止',
    'more': '還有更多腳本，可繼續查詢。',
    'revision': '第 {revision} 版',
    'synced': '已同步',
    'syncing': '同步中',
    'sync_failed': '同步失敗',
    'sync_unknown': '同步狀態未知',
  },
  'video_script_preview': {
    'title': '視頻腳本預覽',
    'untitled': '未命名腳本',
    'status_writing': '編寫中',
    'status_saving': '保存中',
    'status_syncing': '同步中',
    'save_success_requote': '腳本已更新，請重新報價',
    'status_saved': '已保存',
    'status_error': '保存失敗',
    'error': '腳本保存失敗',
    'edit': '編輯',
    'document': '文件',
    'copy': '複製全文',
    'download': '下載',
    'copy_success': '已複製全文',
    'loading': '載入中',
    'save': '保存新版本',
    'cancel': '取消',
    'content_placeholder': '使用 Markdown 編輯影片腳本',
    'content_required': '請輸入腳本正文',
    'retry': '重新載入',
    'load_failed': '腳本讀取失敗',
    'save_failed': '腳本儲存失敗，請稍後重試。目前的編輯內容已保留。',
    'save_auth_failed': '暫時無法儲存，編輯內容已保留。請稍後重試。',
    'save_revision_conflict': '腳本已有新版本，無法覆寫儲存。目前的編輯內容已保留，請基於最新版本重新編輯。',
    'save_pending': '腳本正在同步或儲存中，請稍後重試。目前的編輯內容已保留。',
  },
  'failed_to_load_chat_records': '加載聊天記錄失敗：',
  'error': '報錯了',
  'clear_failed_please_try_again_later': '清除失敗，請稍後重試',
  'operation_failed_please_try_again_later': '操作失敗，請稍後重試',
  'current_agent_does_not_support_image_function': '當前智能體不支持圖片功能',
  'unsupported_image_format': '不支持的圖片格式:',
  'upload_image_cannot_be_larger_than_50M': '上傳圖片不能大於20M',
  'files_current_selected_file_count': '個文件，當前選擇文件數量',
  'upload_avatar_image_can_only_be_JPG_PNG_GIF_WEBP_format': '上傳頭像圖片只能是JPG、PNG、GIF、WEBP格式!',
  'upload_image_size_cannot_exceed_50M': '上傳圖片大小不能超過20M!',
  'upload_failed': '上傳失敗',
  'image_index_label': '圖{index}',
  'image_saved_successfully': '圖片保存成功',
  'failed_to_save_image': '保存圖片失敗:',
  'image_save_failed': '圖片保存失敗',
  'loading_image': '正在加載圖片',
  'network_error': '網絡錯誤，發送失敗。',
  'copy': '複製',
  'share': '分享',
  'save_note': '保存筆記',
  'copy_success': '複製成功',
  'copy_failed': '複製失敗，請稍後重試！',
  'timeout_retry': '回答超時請稍後重試。',
  'regenerate': '重新生成',
  'cancel_like': '取消讚',
  'good_answer': '答得不錯',
  'cancel_dislike': '取消踩',
  'not_good_enough': '還不夠好',
  'close': '關閉',
  'submit': '提交',
  'dislike_reasons': {
    'not_good_enough': '還不夠好',
    'irrelevant': '與問題無關',
    'inaccurate': '內容不準確',
    'misinformation': '有不實信息',
    'misleading_values': '錯誤的價值觀導向',
    'prejudice': '存在偏見歧視',
    'violates_rights': '侵犯他人權益',
    'other_feedback': '我要吐槽'
  },
  'select_dislike_reason': '請選擇您要點踩的內容~~',
  'document_name': '文檔名稱',
  'enter_document_name': '請輸入文檔名稱',
  'search_project': '搜索項目',
  'add_as_subdocument': '添加為子文檔',
  'add_as_subwebdocument': '添加為子網頁',
  'unnamed_document': '未命名文檔',
  'add_success': '添加成功',
  'get_recent_list_failed': '獲取最近訪問列表失敗',
  'select_target_document': '選擇目標文檔',
  'insert_current_document': '插入當前文檔',
  'agent_deleted': '此智能體已刪除！',
  'agent_taken_down': '此智能體已下架！',
  'enter_to_send': '傳送訊息...',
  'file_limit_error': '每次最多選擇{multiLimit}個文件，當前選擇文件數量{filesLength}',
  'verification_failed': '驗證失敗',
  'loading': '加載中',
  'no_more': '沒有更多了',
  'operation_failed': '操作失敗，請稍後重試',
  'load_chat_history_failed': '加載聊天記錄失敗：{message}',
  'clear_success': '清除成功',
  'clear_failed': '清除失敗，請稍後重試',
  'quota_exceeded': '額度超限',
  'content_violation': '內容違規',
  'unavailabled_agent': '当前智能體使用的模型已不在可用，請更新模型設置後繼續對話',
  'click_to_update_model': '点击更新模型',
  'input_length_exceeded': '輸入長度超出限制',
  'point_not_enough': '積分不足，請充值後繼續對話',
  'thinking': '思考中...',
  'processing_thinking': '正在思考...',
  'processing_summarizing': '正在整理對話上下文...',
  'thinking_error': '思考遇到問題',
  'thinking_start': '開始思考',
  'thinking_end': '思考完成',
  'chat_system_is_busy': '系統繁忙,正在為您重新回答',
  'system_is_busy': '系统繁忙',
  'go_back': '後退',
  'go': '前進',
  'refresh': '重新整理',
  'full_screen': '全螢幕',
  'new_link_open': '在新分頁開啟',
  'preview': '預覽',
  'code': '程式碼',
  'edit': '編輯',
  'mobile_view': '行動裝置檢視',
  'desktop_view': '桌面檢視',
  'code_download': '下載程式碼',
  'view_version_list': '查看版本列表',
  'version_history': '版本歷史',
  'version': '版本: {version_number}',
  'generate_on': '生成於 {date}',
  'current_version': '目前',
  'version_switched': '已切換到所選版本',
  'no_version_download': '暫無可下載的版本',
  'download_start': '已開始下載項目',
  'version_loading': '載入中..',
  'version_empty': '暫無版本',
  'version_nomore': '沒有更多了',
  'version_status_ready': '可運行',
  'version_status_fail': '失敗',
  'version_status_building': '構建中',
  'open_web_editor': '預覽網頁',
  'no_version_preview': '暫無可預覽的網頁版本',
  'close_web_mode': '關閉網頁模式',
  'web_build_error': '此版本未能成功生成，無法預覽。',
  'web_build_error_pls_fix': '項目構建錯誤，是否修復？',
  'web_error_fix': '修復',
  'repair_in_progress': '請稍候，我們正在修復您的頁面',
  'file_directory': '目錄結構',
  'choose_file_to_view': '選擇一個文件進行查看',
  'selectFile': '從左側文件樹中選擇一個文件來查看代碼',
  'maxSize': '最大 5MB,支持常見圖片格式',
  'uploadImage': '拖放或貼上圖片到此處，或點擊上傳',
  'text': '文本',
  'no_text_content': '無文本內容',
  'edit_text': '編輯文本',
  'link': '鏈接',
  'edit_link': '編輯鏈接',
  'add_link': '添加鏈接',
  'image': '圖片',
  'chat': '對話',
  'apply': '應用',
  'replace': '替換',
  'replace_image': '替換圖片',
  'upload': '上傳',
  'confirm_crop': '確認裁剪',
  'crop_ratio_auto': '自適應',
  'crop_ratio_free': '自由',
  'crop_ratio_original': '原圖比例',
  'send': '傳送',
  'no_available_chat_mode': '暫無可用聊天模式',
  'web_search': '網頁搜尋',
  'web_search_description': '搜尋網路以取得最新資訊',
  'external_skill_entry': '技能',
  'external_skill_catalog': '全部技能',
  'external_skill_recent_used': '最近使用',
  'external_skill_recent_empty': '暫無使用紀錄，使用技能後將顯示在這裡',
  'external_skill_catalog_desc': '選擇適用於目前智能體類型的自訂技能，快速帶入描述',
  'external_skill_refresh': '重新整理',
  'external_skill_loading': '技能載入中...',
  'external_skill_empty': '目前智能體類型暫無可用自訂技能',
  'external_skill_empty_presets': '暫無可用預設',
  'external_skill_all': '全部',
  'external_skill_catalog_suffix': '技能',
  'external_skill_categories': '技能分類',
  'external_skill_search': '搜尋技能',
  'external_skill_uncategorized': '其他技能',
  'external_skill_preset': '技能預設',
  'external_skill_preview': '描述預覽',
  'external_skill_preview_action': '預覽描述',
  'external_skill_insert': '帶入輸入框',
  'external_skill_insert_description': '帶入到描述',
  'external_skill_generate': '生成',
  'external_skill_back': '返回全部技能',
  'external_skill_examples': '技能案例',
  'external_skill_example_image': '案例圖片 {number}',
  'external_skill_example_video': '案例影片 {number}',
  'external_skill_examples_empty': '暫無圖片或影片案例',
  'external_skill_example_loading': '正在載入案例…',
  'external_skill_example_failed': '案例載入失敗',
  'external_skill_example_headphones': '耳機商品範例圖',
  'external_skill_example_watch': '腕錶商品範例圖',
  'external_skill_example_camera': '相機商品範例圖',
  'external_skill_example_perfume': '香水商品範例圖',
  'external_skill_no_fields': '此預設無需額外設定',
  'external_skill_load_failed': '技能載入失敗，請稍後再試',
  'external_skill_detail_failed': '預設詳情載入失敗',
  'external_skill_preview_failed': '描述預覽失敗，請稍後再試',
  'external_skill_upload_image': '上傳圖片',
  'external_skill_upload_file': '上傳檔案',
  'external_skill_upload_too_large': '檔案大小超出限制',
  'external_skill_upload_image_only': '請選擇圖片檔案',
  'external_skill_upload_type_not_allowed': '檔案類型不符合預設要求',
  'external_skill_upload_failed': '上傳失敗，請稍後再試',
  'external_skill_upload_limit': '已達到上傳數量限制',
  'external_skill_field_required': '必填',
  'external_skill_field_number': '請輸入有效數值',
  'external_skill_field_min': '最小值 {min}',
  'external_skill_field_max': '最大值 {max}',
  'external_skill_field_step': '步長 {step}',
  'external_skill_field_step_from': '從 {min} 起，步長 {step}',
  'external_skill_field_precision': '最多 {precision} 位小數',
  'external_skill_field_min_length': '至少輸入 {min} 個字元',
  'external_skill_field_max_length': '最多輸入 {max} 個字元',
  'external_skill_field_max_count': '最多選擇 {count} 項',
  'external_skill_field_option': '請選擇有效選項',
  'external_skill_field_upload': '請上傳有效檔案',
  'external_skill_field_max_size': '單一檔案不能超過 {size} MB',
  'external_skill_field_accept': '支援格式：{accept}',
  'mixture_of_agents_brief': '自動混合最佳 AI 模型以完成您的任務。',
  'element_chat': '元素對話',
  'ask_about_element': '詢問有關此元素的內容...',
  'version_add_error': '版本異常，無法添加到項目',
  'web_error_regenerate': '重新生成',
  'conversation_not_exist': '對話不存在或已被刪除',
  'img_upload_fail': '圖片上傳失敗',
  'no_img_url': '未獲取到圖片地址',
  'replace_img_success': '圖片替換成功',
  'no_element_selected_or_invalid': '未選中任何元素或元素無效',
  'text_cannot_be_empty': '文本不能為空',
  'original_text_cannot_be_empty': '原文本不能為空',
  'cannot_locate_source_file': '無法定位元素源文件',
  'replace_failed_cannot_locate_file': '替換失敗：無法定位文件位置',
  'replace_failed': '替換失敗：{message}',
  'link_cannot_be_empty': '鏈接不能為空',
  'cannot_get_original_image_url': '無法獲取原圖片地址',
  'no_image_selected': '未選擇圖片',
  'image_size_exceeds_limit': '圖片大小不能超過 5MB',
  'image_upload_failed': '圖片上傳失敗',
  'image_processing_failed': '圖片處理失敗',
  'send_request_failed': '發送請求失敗',
  'sources':'來源',
  'file_upload_limit_error':'最多允許上傳{filesLength}個文件',
  'copy_image': '複製圖片',
  'download_full_size': '下載完整尺寸',
  'edit_image': '引用圖片',
  'edit_image_failed': '引用圖片失敗',
  'download_failed': '下載失敗',
  'image_already_added': '該圖片已添加',
  'upgrade_subscription_download_code': '升級訂閱可下載完整程式碼',
  'tool_calls_empty': '無工具調用',
  'tool_calls_count': '調用了 {count} 次工具',
  'tool_group_count': '調用了 {count} 次工具',
  'tool_calls_single': '調用了 {tool}',
  'tool_calls_summary': '調用了 {count} 次工具：{summary}',
  'todo_progress_step': '第 {current} / {total} 步',
  'tool_result_empty': '暫無工具結果',
  'tool_status_success': '完成',
  'tool_status_running': '進行中',
  'tool_status_failed': '失敗',
  'tool_status_stopped': '已停止',
  'tool_status_warning': '警告',
  'tool_status_pending': '等待中',
  'tool_summary_seconds': '{seconds}s',
  'tool_detail_files_changed': '變更文件',
  'tool_detail_commands': '命令',
  'tool_detail_logs': '執行日誌',
  'tool_detail_arguments': '參數',
  'tool_detail_raw_result': '原始結果',
  'tool_detail_template': '框架',
  'tool_detail_project': '項目標題',
  'tool_detail_install_dependencies': '安裝依賴',
  'tool_detail_deploy': '部署',
  'tool_detail_version': '版本',
  'tool_detail_source': '來源',
  'tool_detail_response_time': '耗時',
  'tool_detail_continuation': '續寫次數',
  'tool_detail_error': '錯誤',
  'tool_batch_query_count': '{count} 個查詢',
  'tool_search_result_count': '{count} 條結果',
  'tool_vertical_domain_count': '{count} 個領域',
  'tool_vertical_capability_count': '{count} 項能力',
  'tool_extract_content_title': '提取內容',
  'clarification_title': '補充確認',
  'clarification_loading_title': '正在梳理需求',
  'clarification_loading_desc': 'PAITEAMS 正在整理問題卡片，請稍候',
  'clarification_progress': '{answered}/{total}',
  'clarification_progress_percent': '{percent}%',
  'clarification_progress_empty': '0/0',
  'clarification_required': '必填',
  'clarification_multi_select': '可多選',
  'clarification_multi_select_suffix': '（選擇所有適用項）',
  'clarification_note_placeholder': '補充信息（可選）',
  'clarification_skip': '跳過',
  'clarification_prev': '上一題',
  'clarification_next': '下一步',
  'clarification_submit': '提交',
  'tool_name_ask_clarification': '補充確認',
  'tool_name_ask_user_questions': '需求確認',
  'tool_name_web_search': '網頁搜索',
  'tool_name_image_search': '圖片搜索',
  'tool_name_image_generation': '圖片生成',
  'tool_name_video_script_list': '影片腳本目錄',
  'tool_name_video_script_read': '讀取影片腳本',
  'tool_name_video_generation_quote': '影片生成報價',
  'tool_name_video_script_save': '編寫影片腳本',
  'tool_name_video_generation_execute': '生成影片',
  'tool_name_remove_background': '移除背景',
  'tool_name_web_image_generation': '生成圖片',
  'tool_name_web_fetch': '網頁抓取',
  'tool_name_read_file': '讀取文件',
  'tool_name_load_skill': '載入技能',
  'tool_skill_visual_design': '視覺設計',
  'tool_skill_web_development': '網頁開發',
  'tool_reference_design_catalog': '設計規範目錄',
  'tool_reference_showcase_catalog': '案例目錄',
  'tool_reference_design_guideline': '設計規範',
  'tool_reference_design_example': '設計案例',
  'tool_name_write_file': '寫入文件',
  'tool_name_ls': '列出項目',
  'tool_name_bash': '執行命令',
  'tool_name_str_replace': '替換文本',
  'tool_name_write_todos': '任務步驟',
  'tool_name_web_dev_save_project': '項目設計方案',
  'tool_name_web_dev_read_project': '讀取項目',
  'tool_name_web_dev_select_template': '選擇框架',
  'tool_name_web_dev_code_generate': '生成程式碼',
  'tool_name_web_dev_build': '構建部署',
  'tool_name_batch_search': '批量搜索',
  'tool_name_extract': '閱讀內容',
  'tool_name_get_sub_domains': '垂直搜索',
  'tool_name_tool_search': '工具檢索',
  'tool_name_tool': '工具',
  'tool_name_query_tool': '查詢工具',
  'media_canvas': {
    'open': '打開畫布',
    'close': '關閉畫布',
    'save': '保存',
    'saving': '保存中',
    'saved': '已保存',
    'unsaved': '未保存',
    'save_failed': '保存失敗',
    'version_conflict': '畫布版本已更新，請刷新後再保存',
    'version_conflict_title': '文件版本落後',
    'version_conflict_description': '您的文件版本已落後，您可能在其他瀏覽器標籤頁中打開了同一項目。請刷新瀏覽器獲取最新版本。',
    'version_conflict_refresh': '刷新',
    'assets': '素材',
    'empty_assets': '暫無素材。上傳、貼上或生成圖片後會出現在這裡。',
    'video': '影片',
    'video_previews': '影片預覽',
    'video_scripts': '影片腳本文件',
    'play_video': '播放影片',
    'pause_video': '暫停影片',
    'video_unavailable': '影片暫時無法播放',
    'unnamed_asset': '未命名素材',
    'upload_asset': '上傳素材',
    'close_assets': '收起素材',
    'hide_asset': '隱藏圖片',
    'show_asset': '顯示圖片',
    'add_to_chat': '添加到對話中',
    'edit_image': '改圖',
    'text_edit_region_label': '文字段落 {index}',
    'text_edit': '編輯文字',
    'text_edit_rewrite': '修改文字',
    'text_edit_extract': '提取文字',
    'text_edit_erase': '消除文字',
    'text_edit_recognition_in_progress': '原圖正在識別，請等待目前識別完成，不要重複發起呼叫。',
    'text_edit_model_billing_unavailable': '環境預設圖片模型的計費設定不可用，請聯絡管理員；不會自動切換模型。',
    'text_edit_request_conflict': '請求關聯資訊不一致，請先查詢原任務再重試，避免重複生成。',
    'text_edit_regions': '圖片識別文字框',
    'text_edit_recognizing': '正在識別文字……',
    'text_edit_verifying_source': '正在核驗原圖，請稍候……',
    'text_edit_source_verification_unavailable': '暫時無法核驗原圖，已保留辨識結果，請點擊重新核驗。',
    'text_edit_recheck_source': '重新核驗',
    'text_edit_probing_metadata': '正在核驗原圖尺寸和檔案大小……',
    'text_edit_context_unavailable': '目前圖片缺少對話資訊，暫時無法編輯文字',
    'text_edit_missing_metadata': '缺少原圖尺寸或檔案大小，請等待核驗後重試',
    'text_edit_metadata_failed': '原圖資訊核驗失敗，請點擊提示或重新選擇圖片後重試',
    'text_edit_source_timeout': '原圖讀取逾時，請稍後重試。',
    'text_edit_source_unavailable': '原圖讀取失敗，請稍後重試。',
    'text_edit_source_decode_failed': '原圖格式或內容無效，請重新上傳圖片後重試。',
    'text_edit_source_too_large': '文字編輯僅支援原圖長邊不超過 3840px、短邊不超過 2160px，且檔案不超過 10MB',
    'text_edit_missing_url': '目前圖片缺少有效原圖位址',
    'text_edit_unsupported_format': '文字編輯僅支援目前畫布既有的 JPG、PNG 和 WEBP 格式',
    'text_edit_no_text': '未辨識到文字。',
    'text_edit_select_region': '請點擊圖片上的一個完整文字框',
    'text_edit_recognized_text': '識別內容（請核對）',
    'text_edit_new_text': '替換文字',
    'text_edit_new_text_placeholder': '輸入要替換的新文字',
    'text_edit_rewrite_submit': '套用修改',
    'text_edit_erase_submit': '消除所選文字',
    'text_edit_erase_confirm': '僅消除已選框的文字並修復背景，結果插入旁邊，原圖不變。',
    'text_edit_generation_hint': '複雜背景下效果可能不穩定；不保證字型、透視、顏色和生成文字完全還原。結果保留原圖並插入旁邊。',
    'text_edit_copy': '複製文字',
    'text_edit_copied': '文字已複製',
    'text_edit_manual_copy': '請長按或使用快捷鍵手動複製。',
    'text_edit_recognize_again': '重新識別',
    'text_edit_recognize_again_hint': '重新識別會發起新的 OCR 呼叫，並按實際呼叫計費',
    'text_edit_check_status': '查詢工作狀態',
    'text_edit_checking': '正在查詢……',
    'text_edit_check_unconfirmed': '本次查詢仍未確認結果；可繼續查詢，符合條件時可結束等待。',
    'text_edit_query_failed': '查詢失敗，請檢查網路或稍後重試；原任務不會自動重新生成。',
    'text_edit_query_timeout': '查詢逾時，請稍後重試；這不代表生成失敗。',
    'text_edit_query_succeeded': '原任務已完成，已恢復處理結果。',
    'text_edit_last_check': '最近查詢 {time}：{status}',
    'text_edit_end_wait': '結束等待',
    'text_edit_end_wait_confirm': '結束本次等待後可手動重新生成，但不保證供應商已取消原請求，新的生成可能另行計費。確定結束等待？',
    'text_edit_wait_ended': '已結束本次等待，可以重新選擇文字並手動生成。',
    'text_edit_recovery_action_required': '工作狀態查詢已暫停，請檢查登入或存取權限後重試。',
    'text_edit_multiline_hint': '此框包含多行文字，首版不會自動合併相鄰文字框，請核對換行。',
    'text_edit_edge_hint': '目標文字靠近原圖邊緣，背景上下文有限，生成效果可能下降。',
    'text_edit_vertical_hint': '目標框可能為直排文字，請核對內容和排版；生成效果可能下降。',
    'text_edit_tilted_hint': '目標文字可能傾斜或帶透視，生成效果可能下降。',
    'text_edit_crop_hint': '裁切範圍外或被截斷的文字框不可選，請先調整圖片裁切範圍。',
    'text_edit_invalid_regions_hint': '部分識別框座標無效或 ID 重複，已略過；不會使用錯誤座標。',
    'text_edit_invalid_ocr': '識別結果的座標或關聯資訊無效，無法安全編輯，請重新識別。',
    'text_edit_empty_text': '內容不可為空；移除文字請使用「消除文字」。',
    'text_edit_same_text': '新文字與原文字相同，無需生成。',
    'text_edit_text_too_long': '內容過長，請縮短後提交。',
    'text_edit_protected_overlap': '此文字框與未選取的文字框重疊，無法單獨處理。',
    'text_edit_unsafe_region': '此文字框無法安全處理，請核對識別範圍。',
    'text_edit_overlap_conflict': '同一位置的識別框填寫了不同內容，無法同時修改。',
    'text_edit_local_input_limit': '原圖規格或比例不符合預設生圖模型的文字編輯限制。',
    'text_edit_processing': '文字處理工作正在進行，請稍候。',
    'text_edit_submitting': "正在提交…",
    'text_edit_timeout': "圖片處理逾時，佔位已移除，可以重新生成。",
    'text_edit_wait_connection': "等待已結束，正在恢復任務狀態；網絡恢復後會自動確認是否可以重新生成。",
    'text_edit_busy': '目前有其他請求正在處理，請稍後重試',
    'text_edit_failed': '文字處理失敗，請核對後重試',
    'text_edit_generation_failed_retry': '生成失敗，請重試',
    'text_edit_unknown': '生成失敗，請重試',
    'text_edit_result_unconfirmed': '正在自動確認文字處理結果，請稍候。',
    'text_edit_tool_unavailable': '預設 OCR 工具無法使用，請聯絡管理員。',
    'text_edit_model_unavailable': '環境預設圖片模型未設定或不可用，請聯絡管理員',
    'text_edit_model_unsupported': '預設模型不支援圖片編輯，請聯絡管理員。',
    'text_edit_recognition_expired': '辨識已過期，請重新辨識。',
    'text_edit_source_changed': '原圖或原始尺寸已變更，請重新選擇圖片並識別',
    'text_edit_recognition_failed': '文字辨識暫時失敗，請稍後重試',
    'text_edit_recognition_unknown': '文字辨識失敗，請重試。',
    'text_edit_content_rejected': '目前圖片或替換文字未通過內容審核，請調整後重試',
    'text_edit_rate_limited': '文字服務請求過於頻繁，請稍後重試',
    'text_edit_points_insufficient': '點數不足，請儲值後重試',
    'text_edit_service_unavailable': '文字編輯服務暫不可用，請稍後重試',
    'expand': '擴圖',
    'expand_title': '擴圖',
    'expand_description': '選擇最終畫布比例，原圖保持比例並置中，不裁剪、不拉伸。',
    'expand_drag_hint': '拖動邊緣或角點調整擴展範圍',
    'expand_ratio_too_large': '此比例超出單邊 5824px 上限，請拖動調整範圍',
    'expand_custom': '自訂',
    'expand_width': '寬度',
    'expand_height': '高度',
    'expand_submit': '開始擴圖',
    'expand_source_too_large': '原圖長邊超過 4160 像素，無法擴圖',
    'expand_custom_invalid': '請輸入 1–5824 的整數尺寸',
    'expand_custom_must_contain': '自訂畫布寬高不能小於原圖',
    'expand_target_unreachable': '目前尺寸和原圖位置無法完成擴圖，請調整寬高或原圖位置',
    'expand_round_limit': '目前擴圖範圍超過可完成的輪次，請縮小範圍或調整原圖位置',
    'expand_no_change': '目標尺寸與原圖相同，請擴大擴圖範圍',
    'expand_failed_retry': '擴圖失敗，請重新生成',
    'edit_prompt_placeholder': '描述你想如何修改圖片',
    'high_definition': '高清',
    'high_definition_output_size': '選擇放大倍數和輸出尺寸',
    'high_definition_scale': '{scale} 倍',
    'high_definition_preserve_alpha': '透明通道將盡量保留',
    'high_definition_limit_option': '輸出任一邊不能超過 {max} 像素',
    'high_definition_invalid_selection': '請選擇一張已就緒的圖片',
    'high_definition_missing_url': '目前圖片缺少有效素材位址',
    'high_definition_unsupported_format': '高清僅支援 JPG、PNG 和 WEBP 圖片',
    'high_definition_missing_dimensions': '缺少圖片原始尺寸，請等待服務端探測後重試',
    'high_definition_probing_dimensions': '正在探測圖片原始尺寸',
    'high_definition_limit_reached': '目前圖片尺寸已達到服務上限（{max} 像素），無法繼續放大',
    'high_definition_failed_retry': '高清處理失敗，請重試',
    'high_definition_source_too_large': '圖片超過20MB，請壓縮後重試',
    'high_definition_status_uncertain': '任務狀態暫未確認；再次重試會繼續使用原任務',
    'remove_background_prompt': '請去除這張圖片的背景，並輸出透明背景圖片。',
    'remove_background_failed_retry': '去背景失敗，請重新生成',
    'eraser': '橡皮擦',
    'eraser_title': '橡皮擦',
    'eraser_description': '塗抹需要消除的區域，生成後不會覆蓋原圖。',
    'eraser_brush': '畫筆',
    'eraser_mask_eraser': '遮罩橡皮',
    'eraser_brush_size': '筆刷大小',
    'eraser_undo': '復原',
    'eraser_redo': '重做',
    'eraser_reset': '重設',
    'eraser_mask_hint': '白色區域會被消除，黑色區域會保留。',
    'eraser_submit': '立即生成',
    'eraser_missing_image': '目前圖片缺少可編輯位址',
    'eraser_missing_dimensions': '缺少圖片原始尺寸，暫時無法使用橡皮擦',
    'eraser_source_too_large': '圖片超過橡皮擦可處理範圍，請壓縮後重試',
    'eraser_bria_source_too_large': '原圖超過 30MB，請壓縮後重試',
    'eraser_capabilities_unavailable': '橡皮擦設定不可用或未設定預設工具，無法安全確認伺服器使用的工具。請檢查後端設定並重試',
    'eraser_capabilities_legacy_fallback': '未能讀取最新橡皮擦設定，暫按原有限制（2560 × 1440、10 MB）編輯；未切換供應商。BRIA 大圖請稍後重試。',
    'eraser_resource_unavailable': '目前瀏覽器無法處理這張原尺寸圖片，請嘗試記憶體更充足的裝置（圖片未縮放）',
    'eraser_image_load_failed': '圖片載入失敗，請重試',
    'eraser_mask_export_failed': '遮罩匯出失敗，請重試',
    'eraser_invalid_input': '遮罩或圖片尺寸無效，請修改後重試',
    'eraser_service_unavailable': '橡皮擦服務暫不可用',
    'eraser_rate_limited': '服務繁忙，請稍後重試',
    'eraser_content_rejected': '目前圖片或消除區域不符合服務規則',
    'eraser_result_unknown': '結果待確認，請稍後查看任務狀態',
    'eraser_failed_retry': '消除失敗，請重新生成',
    'untitled': '未命名畫布',
    'need_conversation': '請先建立會話後再添加畫布素材',
    'upload_missing_url': '上傳成功但未返回文件地址',
    'asset_create_failed': '素材建立失敗',
    'asset_rename_failed': '素材重新命名失敗',
    'asset_delete_failed': '刪除素材失敗，請重試',
    'export': {
      'open': '匯出',
      'close': '關閉匯出',
      'title': '匯出',
      'export_type': '匯出類型',
      'image': '圖片',
      'format': '圖片格式',
      'original_format': '原圖格式（自動匹配）',
      'size': '匯出尺寸',
      'original_size': '原圖尺寸',
      'scale_value': '{scale} 倍',
      'download_range': '下載範圍',
      'download_content': '下載內容',
      'download_count': '下載內容 {count}',
      'all_selected_content': '全選圖片',
      'max_selected_assets': '單次最多選擇 {count} 張圖片',
      'selection_limit_reached': '不能超過 {max} 張圖片',
      'export_mode': '匯出方式',
      'separate': '分開下載',
      'long_image': '拼成一張',
      'separate_detail': '多張圖片將分別處理並打包為 ZIP 檔案',
      'watermark': 'LOGO',
      'logo_watermark': '平台 LOGO',
      'membership_required': '基礎版必選',
      'watermark_position': 'LOGO 位置',
      'position_top_left': '左上',
      'position_top_center': '中上',
      'position_top_right': '右上',
      'position_middle_left': '左',
      'position_center': '中',
      'position_middle_right': '右',
      'position_bottom_left': '左下',
      'position_bottom_center': '中下',
      'position_bottom_right': '右下',
      'kicker': '畫布匯出工作區',
      'asset_hint': '選擇圖片並逐張調整匯出參數',
      'output_settings': '輸出設定',
      'output_settings_hint': '格式和倍率套用於本次匯出',
      'pixel_width': '主圖寬度（像素）',
      'pixel_height': '主圖高度（像素）',
      'lock_aspect_ratio': '鎖定寬高比',
      'resize_mode': '尺寸方式',
      'resize_mode_exact': '寬高都一致',
      'resize_mode_width': '寬度一致',
      'resize_mode_height': '高度一致',
      'resize_mode_fit': '等比例適應',
      'image_apply_mode': '套用方式',
      'image_properties': '圖片屬性',
      'image_properties_hint': '每張圖片可以單獨設定',
      'apply_single': '套用單張',
      'apply_selected_all': '套用全部已選',
      'sync_properties_to_selected_images': '套用至選取圖片',
      'apply_image_settings': '同步',
      'sync_logo_to_selected_images': 'LOGO 同步至所有選取圖片',
      'apply_image_to_selected': '像素套用至已選',
      'custom_watermark': '使用者專屬 LOGO',
      'custom_watermark_hint': '可上傳專屬 LOGO 並拖動調整位置',
      'watermark_image': '圖片 LOGO',
      'no_watermark_short': '無 LOGO',
      'no_custom_watermark': '不添加使用者專屬 LOGO',
      'upload_watermark': '上傳 LOGO',
      'uploading_watermark': '上傳中',
      'watermark_upload_success': 'LOGO 已新增',
      'watermark_upload_failed': 'LOGO 上傳失敗，請重試',
      'delete_watermark': '刪除 {name}',
      'watermark_delete_title': '確認刪除 LOGO',
      'watermark_delete_confirm': '確定要刪除「{name}」嗎？刪除後將無法在匯出中使用。',
      'watermark_delete_confirm_button': '刪除',
      'watermark_delete_success': 'LOGO 已刪除',
      'watermark_delete_failed': 'LOGO 刪除失敗，請重試',
      'watermark_format_invalid': '僅支援 PNG、JPG、WEBP LOGO',
      'watermark_file_too_large': 'LOGO 檔案不能超過 5MB',
      'watermark_rotation': 'LOGO 角度（°）',
      'watermark_opacity': 'LOGO 透明度（%）',
      'drag_watermark': '拖動預覽中的 LOGO 調整位置',
      'resize_watermark': '拖動 LOGO 角點調整大小',
      'watermark_position_hint': '快速定位或拖動預覽中的 LOGO',
      'watermark_pixel_settings': 'LOGO 像素',
      'advanced_settings': '進階設定',
      'watermark_pixel_settings_hint': '依匯出尺寸精確設定 LOGO 位置與大小',
      'watermark_pixel_x': 'LOGO X（像素）',
      'watermark_pixel_y': 'LOGO Y（像素）',
      'watermark_pixel_width': 'LOGO 寬度（像素）',
      'watermark_pixel_height': 'LOGO 高度（像素）',
      'image_setting_uniform': '圖片統一設定',
      'image_setting_individual': '圖片單獨設定',
      'logo_setting_uniform': 'Logo統一設定',
      'logo_setting_individual': 'Logo單獨設定',
      'no_logo': '無 Logo',
      'cancel': '取消',
      'submit': '匯出',
      'exporting': '匯出中',
      'exporting_progress': '匯出素材 {current}/{total}',
      'export_progress_estimate': '預估進度',
      'export_progress_preparing': '準備匯出',
      'export_progress_rendering': '正在處理素材',
      'export_progress_packaging': '正在整理檔案',
      'export_progress_complete': '匯出完成',
      'empty_canvas': '素材庫中暫無可匯出的圖片',
      'save_before_export_failed': '保存畫布失敗，暫時無法匯出',
      'export_success': '匯出完成',
      'download_url_missing': '匯出完成但未返回下載地址，請重試',
      'subscription_required': '升級訂閱後可使用畫布匯出',
      'export_failed': '匯出失敗，請重試',
      'processing_failed': '匯出處理失敗，請重試',
      'processing_timeout': '匯出處理超過 600 秒，請稍後重試',
      'no_images_selected': '請至少選擇一張圖片',
      'invalid_export_mode': '匯出方式無效，請重新選擇',
      'invalid_export_format': '圖片格式無效，請重新選擇',
      'invalid_export_scale': '匯出倍率無效，請重新選擇',
      'invalid_export_asset_ids': '匯出圖片選擇無效，請重新選擇',
      'invalid_export_asset_mode': '單圖僅支援單圖匯出，多圖請選擇分開下載或拼成長圖',
      'invalid_export_manifest': '匯出圖片參數無效，請重新設定',
      'invalid_resize_mode': '圖片尺寸方式無效，請重新選擇',
      'limit_asset_count': '每次最多選擇 {max} 張圖片',
      'limit_mode_count': '單圖匯出需要選擇 1 張圖片，多圖匯出至少需要選擇 2 張圖片',
      'limit_long_asset_count': '拼成長圖最多選擇 {max} 張圖片',
      'limit_output_dimension': '輸出寬高必須是正整數',
      'limit_output_edge': '每張圖片的輸出寬高都不能超過 {maxEdge} 像素',
      'limit_per_image_pixels': '每張圖片的輸出像素不能超過 67,240,000（約 67.24MP，8200 × 8200）',
      'pixel_limit_single': '單圖匯出：寬、高均≤13,000px，且像素≤67,240,000（約 67.24MP，8200 × 8200）；',
      'limit_source_edge': '來源圖片單邊不能超過 {maxSourceEdge} 像素',
      'limit_source_pixels': '來源圖片像素不能超過 67,240,000（約 67.24MP，例如 8,200 × 8,200）',
      'limit_separate_pixels': '分開下載的全部圖片輸出像素總和不能超過 1,280,000,000（1280MP）',
      'limit_long_pixels': '拼成長圖後的畫布像素不能超過 67,108,864',
      'limit_source_file_size': '單個來源檔案不能超過 100MiB',
      'limit_source_total_size': '本次匯出的來源檔案總量不能超過 1,024MiB（1GiB）',
      'pixel_limit_per_image': '分開下載或長圖中的每張輸出圖片：寬、高均≤13,000px，且單張像素≤67,240,000（約 67.24MP，8200 × 8200）；',
      'pixel_limit_separate': '分開下載全部圖片合計≤1,280,000,000 像素；',
      'pixel_limit_long': '拼成長圖按「最大寬度 × 高度總和」計算，畫布≤67,108,864 像素。',
      'scroll_load_more': '繼續下滑載入更多圖片'
    }
  }
}
